<template>
  <div class="icon" v-if="item && item.priceListId">
    <img
      v-if="item.equipmentStatus === 'online'"
      src="~@/assets/img/deviceManagement/printer_p.png"
      alt="付费打印机在线"
    />
    <img
      v-if="item.equipmentStatus === 'offline'"
      src="~@/assets/img/deviceManagement/printer_off_p.png"
      alt="付费打印机离线"
    />
  </div>
  <div class="icon" v-else-if="item && !item.priceListId">
    <img
      v-if="item.equipmentStatus === 'online'"
      src="~@/assets/img/deviceManagement/printer.png"
      alt="打印机在线"
    />
    <img
      v-if="item.equipmentStatus === 'offline'"
      src="~@/assets/img/deviceManagement/printer_off.png"
      alt="打印机离线"
    />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  }
};
</script>

<style scoped lang="scss">
.icon {
  width: 34px;
  height: 34px;
}
</style>
